<template>
    <div class="">
        <data-table-component v-bind="$data"></data-table-component>
    </div>
</template>
<script>
    import Vue from 'vue';
    import DataTableComponent from '../DataTableComponent';

    Vue.component('tdProductLink', {
        props: ['row'],
        template: '<div v-html><a :href="row.link" target="_blank">{{ row.shop }}</a></div>',
    })

    export default
    {
        components: {DataTableComponent},
        props: {
            cols: {
                type: Array,
            },
            productId: {
                type: Number,
            },
            days: {
                type: Number,
            }
        },
        data() {
            return {
                HeaderSettings: false,
                fixHeaderAndSetBodyMaxHeight: 200,
                pageSizeOptions: [50],
                Pagination: false,
                tblStyle: 'table-layout: fixed',
                tblClass: 'table-bordered',
                columns: [],
                data: [],
                total: 0,
                query: {
                    limit: 50,
                    product_id: null,
                    days: null,
                }
            }
        },
        mounted() {
            this.columns = this.configureColumns(this.cols);
            this.query.product_id = this.productId;
            this.query.days = this.days;

            this.getData();
        },
        methods:
        {
            getData()
            {
                this.data = [];
                this.total = 0;

                let data = {
                    product_id: this.productId,
                    days: this.days,
                }

                this.$http.get(this.$route.name + '/dt', {params: data}).then((response) => {
                    this.data = response.body.data;
                    this.total = response.body.recordsTotal;
                })
            },
            configureColumns(columns)
            {
                return columns.map((col, index) => {
                    let colSize = '100px';

                    if (0 == index) {
                        col.tdComp = 'tdProductLink';
                        colSize = '150px';
                    }

                    if (-1 !== [0,1].indexOf(index)) {
                        col.fixed = true;
                    }

                    col.colStyle = { width: colSize };

                    return col;
                });
            }
        },
        watch:
        {
            cols: {
                handler: function() {
                    if (!this.cols.length) {
                        return ;
                    }

                    this.columns = this.configureColumns(this.cols);
                    this.getData();
                }
            },
            productId: {
                handler: function() {
                    this.getData();
                }
            },
            days: {
                handler: function() {
                    this.getData();
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// DataTable.vue?6a2988e1